import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { formatDate, DATE_FORMATS } from '../../../../Timestamp/functions';
var StatusMonoHtmlView = function (props) {
    var deviation = props.deviation, link = props.config.link;
    return (React.createElement(EditorDeviationLink, { link: link, deviation: deviation, linkClass: "gallery-link" },
        React.createElement("div", { className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation), props.config &&
                props.config.alignment &&
                "daeditor-align-".concat(props.config.alignment), props.settings &&
                props.settings.showMediaAlwaysSmall &&
                "daeditor-small") },
            React.createElement("div", { className: "daeditor-freeform-body" },
                React.createElement("div", { className: "daeditor-freeform-date" }, deviation.publishedTime &&
                    formatDate(deviation.publishedTime, DATE_FORMATS.Date.Full)),
                React.createElement("div", { className: "daeditor-freeform-text" }, deviation.textContent && deviation.textContent.excerpt)))));
};
StatusMonoHtmlView.displayName = 'StatusMonoHtmlView';
export default StatusMonoHtmlView;
//# sourceMappingURL=StatusHtml.js.map